export const RESET_APP = '@@app/reset'
